<template>
    <div>
        <topnav :toptype="toptype"></topnav>
        <div class="shenbaoA animated fadeInUp">
            <div class="" style="border: 2px solid #eee; padding: 30px 10px">
                <div
                    class="box1_header"
                    style="margin-bottom: 20px; border: none"
                >
                    <div class="box1_header_shu"></div>
                    <div class="box1_header_text">{{detail.name}}</div>
                </div>
                <div class="flex justify-start align-start">
                    <div style="width: 680px; margin-left: 20px">
                        <div style="font-size: 20px">
                            <!-- <div class="" style="margin-bottom: 20px;margin-top: 10px;">{{detail.name}}</div> -->
                            <div style="margin-bottom: 20px; margin-top: 10px">
                                {{ detail.company }}
                            </div>
                            <div
                                class=""
                                style=" color: gray;font-size: 18px;margin-bottom: 15px;"
                            >
                                {{ detail.title }}
                            </div>
                            <!-- <div class="" style="color: gray;font-size: 16px;margin-bottom: 15px;"> <i class="el-icon-chat-dot-round"></i> {{detail.question_number}}人咨询</div> -->
                            <div @click="shownow" class="zbtn pointer">
                                立即咨询
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div style="color: #878787;">
                <div class="box1_header" style="margin: 20px 0; border: none">
                    <div class="box1_header_shu"></div>
                    <div class="box1_header_text">咨询服务</div>
                </div>
                <div class="flex justify-start align-start" style="margin-bottom: 10px;">
                    <div class="text-right" style="width: 100px;font-size: 15px;line-height: 40px;">公司名称：</div>
                    <el-input v-model="name" placeholder="请输入公司名称"></el-input>
                </div>
                <div class="flex justify-start align-start" style="margin-bottom: 10px;">
                    <div class="text-right" style="width: 100px;font-size: 15px;line-height: 40px;">手机号：</div>
                    <el-input v-model="phone" placeholder="请输入手机号"></el-input>
                </div>
                <div class="flex justify-start align-start" style="margin-bottom: 10px;">
                    <div class="text-right" style="width: 100px;font-size: 15px;line-height: 40px;">咨询内容：</div>
                    <el-input type="textarea" :rows="2" placeholder="请输入咨询内容" v-model="content"></el-input>
                </div>
                <div class="text-center" style="margin-top: 30px;">
                    <el-button @click="tosub" type="primary">提交</el-button>
                </div>
            </div> -->
            <div
                class=""
                style="
                    border: 2px solid #eee;
                    margin-top: 20px;
                    border-top: none;
                "
            >
                <div style="height: 60px; width: 100%; background: #eee">
                    <div
                        style="
                            width: 120px;
                            background: #fff;
                            height: 100%;
                            font-size: 18px;
                            text-align: center;
                            line-height: 60px;
                            border-top: 2px solid #0070c0;
                        "
                        class=""
                    >
                        详细介绍
                    </div>
                </div>
                <div class="sd_content">
                    <!-- <div class="box1_header" style="margin: 20px 0; border: none">
                            <div class="box1_header_shu"></div>
                            <div class="box1_header_text">详细介绍</div>
                        </div> -->
                    <div
                        v-if="detail.content"
                        class=""
                        v-html="detail.content"
                    ></div>
                    <el-empty
                        v-if="!detail.content"
                        description="暂无详细介绍"
                    ></el-empty>
                </div>
            </div>
        </div>
        <div
            v-if="detail"
            @click="shownow"
            class="new_bot flex justify-center align-center pointer"
        >
            <div class="bot_text">
                {{ config.new_detail ? config.new_detail : "" }}
            </div>
            <div class="bot_btn">立即获取</div>
        </div>
        <el-dialog title="咨询" :visible.sync="addcompany">
            <div class="" style="text-align: center; margin: 0 auto">
                <el-form :model="cominfo" style="text-align: center">
                    <el-form-item label="姓名：" :label-width="formLabelWidth">
                        <el-input
                            style="width: 80%; max-width: 450px"
                            placeholder="请输入"
                            v-model="cominfo.name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="电话：" :label-width="formLabelWidth">
                        <el-input
                            style="width: 80%; max-width: 450px"
                            placeholder="请输入"
                            v-model="cominfo.phone"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="咨询内容："
                        :label-width="formLabelWidth"
                    >
                        <el-input
                            style="width: 80%; max-width: 450px"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入咨询内容"
                            v-model="cominfo.content"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="联系电话："
                        :label-width="formLabelWidth"
                    >
                        <div
                            style="
                                text-align: left;
                                font-size: 16px;
                                width: 80%;
                                max-width: 450px;
                                margin: auto;
                            "
                        >
                            {{ config.phone }}
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="flex justify-center align-center">
                <el-button :disabled="nowdisabled" @click="tosub" type="primary"
                    >提 交</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            id: "",
            detail: "",
            toptype: 4,
            name: "",
            phone: "",
            content: "",
            addcompany: false,
            cominfo: {
                question_id: "",
                type: 2,
                company_name: "",
                name: "",
                phone: "",
                content: "",
                user_id: "",
            },
            formLabelWidth: "120px",
            nowdisabled: false,
            config: "",
        };
    },
    computed: {
        ...mapGetters(["token"]),
    },
    methods: {
        getconfig() {
            this.$api.index.config().then((res) => {
                this.config = res.data;
            });
        },
        shownow() {
            if (!this.token) {
                this.$message.error("请登录");
                return false;
            }
            this.addcompany = true;
            this.cominfo.question_id = this.detail.id;
        },
        getdetail() {
            this.$api.index.start_detail({ id: this.id }).then((res) => {
                console.log(res);
                var regex = new RegExp("<img", "gi");
                res.data.content = res.data.content.replace(
                    regex,
                    `<img style="max-width: 100%;height: auto"`
                );
                this.detail = res.data;
            });
        },
        tosub() {
            // question_add
            if (
                !this.cominfo.content ||
                !this.cominfo.phone ||
                !this.cominfo.name
            ) {
                this.$message({
                    message: "请完善信息",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            if (!this.cominfo.phone) {
                this.$message({
                    message: "请输入手机号",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            if (!/^1[3456789]\d{9}$/.test(this.cominfo.phone)) {
                this.$message({
                    message: "手机号码错误！",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            this.cominfo.user_id = this.token;
            this.nowdisabled = true;
            this.$api.index
                .question_add(this.cominfo)
                .then((res) => {
                    console.log(res);
                    this.$message({
                        message: res.msg,
                        type: "none",
                        duration: 1000,
                    });
                    this.addcompany = false;
                    this.cominfo.phone = "";
                    this.cominfo.name = "";
                    this.cominfo.content = "";
                    this.nowdisabled = false;
                })
                .catch((res) => {
                    this.nowdisabled = false;
                });
        },
    },
    created() {
        this.id = this.$route.query.id;
        this.getconfig();
        this.getdetail();
    },
};
</script>
<style scoped>
.sd_content {
    font-size: 22px;
    line-height: 36px;
    color: #737373;
    min-height: 510px;
    padding: 20px 30px;
}
.cardView {
    border: solid #ff9700 1px;
    border-radius: 10px;
    position: relative;
    padding: 20px;
    margin-bottom: 25px;
}
.cardView .tagtext {
    position: absolute;
    background-color: #ff9700;
    padding: 0px 10px;
    border-radius: 15px;
    line-height: 26px;
    color: #ffe;
    top: -15px;
    font-size: 12px;
}
.shenbaoA {
    width: 1000px;
    height: auto;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 20px;
    background: #fff;
    padding: 20px 50px;
    /* border-top: 2px solid #eee; */
}

.sd_title {
    text-align: center;
    border-bottom: 1px solid #eee;
}

.biaoti1 {
    font-size: 22px;
    color: #202020;
    line-height: 42px;
}

.bt_mes {
    font-size: 15px;
    color: #7f7f7f;
    line-height: 35px;
    margin-bottom: 20px;
}

input:focus,
textarea:focus {
    outline: none;
}

.sub_btn {
    width: 185px;
    height: 52px;
    background-color: #ff7900;
    border-radius: 6px;
    border: none;
    font-size: 22px;
    color: #fff;
    margin-top: 25px;
}

.sd_sub {
    padding-bottom: 30px;
    border-bottom: 2px solid #eee;
    text-align: center;
}

.next_all {
    margin-bottom: 30px;
    padding-left: 20px;
}

.next_all .previous,
.next_all ._next {
    color: #7f7f7f;
    line-height: 32px;
}

img {
    max-width: 100%;
}
.box1_header {
    display: flex;
    /* height: 55px; */
    padding: 0 15px;
    align-items: center;
    /* border-bottom: 1px solid #eee; */
}

.box1_header_text {
    font-size: 20px;
    color: #111111;
    font-weight: 600;
    margin-left: 10px;
}

.box1_header_shu {
    width: 4px;
    height: 21px;
    background-color: #0070c0;
}
.zbtn {
    width: 148px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #fff;
    background-image: linear-gradient(86deg, #005aeb 0%, #00a0fd 100%);
    border-radius: 4px;
    font-size: 18px;
}
.new_bot {
    width: 100%;
    height: 70px;
    background-image: linear-gradient(
        0deg,
        #1759d8 0%,
        #107ee4 56%,
        #08a3f0 100%
    );
    margin-top: 30px;
}
.bot_text {
    color: #ffffff;
    font-size: 22px;
}
.bot_btn {
    width: 144px;
    height: 44px;
    background-image: linear-gradient(0deg, #ece2ae 0%, #fffef4 100%);
    border-radius: 22px;
    color: #b97a00;
    line-height: 44px;
    font-size: 20px;
    text-align: center;
    margin-left: 50px;
}
</style>


// WEBPACK FOOTER //
// riskdetail.vue?63862f57